import { ProductType } from '../../shared/enums';
import { isExperience } from '../../shared/product-safeguards';
import { type Product, type ProductGroupItem } from '../../shared/types';

const DELIVERY_FORMAT_GROUP_SIZE = 2;

function isDeliveryFormatGroup(items: ProductGroupItem[] = []): boolean {
    return (
        items.length === DELIVERY_FORMAT_GROUP_SIZE &&
        items.some(item => item.type === ProductType.BOX) &&
        items.some(item => item.type === ProductType.EXPERIENCE)
    );
}

function isAddedToCartDirectly(product: Product): boolean {
    return !isExperience(product) || isDeliveryFormatGroup(product.productGroup);
}

export { isAddedToCartDirectly, isDeliveryFormatGroup };
